import React from 'react'

const ErrorBoundaryFallbackComponent = () => (
  <div style={{ maxWidth: 'max-content', margin: '0 auto' }}>
    Content Unavailable
  </div>
)

export default ErrorBoundaryFallbackComponent
